/**
 * What Assist shows when AI is switched off for the account: the person's
 * own switch on mauvely.com, or their organisation's. Their chats and memory
 * are kept either way; every route but `/me` refuses until it is back on.
 *
 * Not in the prototype. Drawn in its language — one region on the ground, the
 * wordmark, a Baloo title with a full stop — and it says which switch, and
 * where it is when it is theirs to change. An organisation's switch has no
 * button: there is nothing the person can press. Nor has an organisation that
 * has not turned Assist on at all, which is an extra it pays for.
 */

import type { Me } from '../api';
import { ds } from '../ds';

export function AiOff({ me }: { me: Me }) {
  const { Wordmark, Button } = ds();
  const reason = me.ai.reason ?? 'personal';
  const personal = reason === 'personal';

  return (
    <div
      className="mv-app"
      style={{
        height: '100%',
        boxSizing: 'border-box',
        display: 'grid',
        placeItems: 'center',
        padding: 16,
        background: 'var(--app-ground)',
        color: 'var(--text-body)',
        fontFamily: 'var(--font-body)'
      }}
    >
      <main
        style={{
          width: '100%',
          maxWidth: 440,
          boxSizing: 'border-box',
          background: 'var(--app-panel)',
          borderRadius: 'var(--radius-region)',
          padding: '28px 28px 30px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: 14
        }}
      >
        <Wordmark lockup="ink" word="assist" badge="sparkle" size={17} />
        <h1
          style={{
            margin: '10px 0 0',
            fontFamily: 'var(--font-display)',
            fontWeight: 800,
            fontSize: 36,
            lineHeight: 1.02,
            letterSpacing: 'normal',
            color: 'var(--text-strong)'
          }}
        >
          {reason === 'assist' ? 'Assist is off.' : 'AI is off.'}
        </h1>
        <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: 'var(--text-body)' }}>
          {personal
            ? 'You turned off AI features for your account.'
            : reason === 'assist'
              ? 'Your organisation has not turned on Assist.'
              : 'Your organisation has turned off AI for your account.'}
        </p>
        {personal ? (
          <Button
            variant="accent"
            density="app"
            size="sm"
            href={`${me.accountUrl}/account/privacy`}
            style={{ marginTop: 6 }}
          >
            Turn it back on
          </Button>
        ) : null}
      </main>
    </div>
  );
}
